import { render, staticRenderFns } from "./MayConcern.vue?vue&type=template&id=11045246&scoped=true"
import script from "./MayConcern.vue?vue&type=script&lang=js"
export * from "./MayConcern.vue?vue&type=script&lang=js"
import style0 from "./MayConcern.vue?vue&type=style&index=0&id=11045246&prod&lang=scss&scoped=true"
import style1 from "./MayConcern.vue?vue&type=style&index=1&id=11045246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11045246",
  null
  
)

export default component.exports